// src/components/forms/TextArea.jsx
import React from 'react';

const TextArea = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  error,
  required = false,
  disabled = false,
  className = '',
  rows = 4,
  maxLength,
  autoResize = false,
  icon,
  ...props
}) => {
  const id = `textarea-${name}`;

  // Handle auto-resize functionality
  const handleResize = (e) => {
    if (autoResize) {
      e.target.style.height = 'auto';
      e.target.style.height = `${e.target.scrollHeight}px`;
    }
  };

  const handleChange = (e) => {
    if (autoResize) {
      handleResize(e);
    }
    onChange(e);
  };

  return (
    <div className={['form-field', 'textarea-field', className].filter(Boolean).join(' ')}>
      {label && (
        <label
          htmlFor={id}
          className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-900 dark:text-white"
        >
          {icon && (
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-blue-50 text-blue-700 ring-1 ring-blue-100 dark:bg-blue-950/40 dark:text-blue-200 dark:ring-blue-900/40">
              {icon}
            </span>
          )}
          <span className="inline-flex items-center gap-1">
            {label}
            {required && <span className="text-red-500">*</span>}
          </span>
        </label>
      )}

      <textarea
        id={id}
        name={name}
        value={value || ''}
        onChange={handleChange}
        onInput={autoResize ? handleResize : undefined}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        rows={rows}
        maxLength={maxLength}
        className={[
          'w-full',
          'rounded-xl',
          'border',
          'bg-white',
          'px-4',
          'py-3',
          'text-sm',
          'font-medium',
          'text-slate-900',
          'shadow-sm',
          'outline-none',
          'transition',
          'placeholder:text-slate-400',
          'focus:ring-2',
          'disabled:cursor-not-allowed',
          'disabled:opacity-60',
          'dark:bg-slate-900',
          'dark:text-white',
          'dark:placeholder:text-slate-500',
          error
            ? 'border-red-300 ring-red-500/20 dark:border-red-900/50 dark:ring-red-500/20'
            : 'border-slate-200 focus:border-blue-300 focus:ring-blue-500/20 dark:border-slate-800 dark:focus:border-blue-900/50 dark:focus:ring-blue-500/20',
          autoResize ? 'resize-none' : 'resize-y',
        ].join(' ')}
        {...props}
      />

      {maxLength && value && (
        <div className="mt-1 text-right text-xs font-medium text-slate-500 dark:text-slate-400">
          {value.length}/{maxLength}
        </div>
      )}

      {error && (
        <div className="mt-2 text-sm font-medium text-red-600">
          {error}
        </div>
      )}
    </div>
  );
};

export default TextArea;
